export function stationToKm220MapPort(station) {
  if (!station) {
    return null;
  }
  return {
    number: station.portNumber ?? station.number,
    deviceId: station.deviceId,
    plugType: station.plugType,
    maxPowerWt: station.maxPowerWt,
    costPerKwt: station.costPerKwt,
    notesUa: station.notesUa,
    notesEn: station.notesEn,
    webcamUrl: station.webcamUrl,
    longitude: station.longitude,
    latitude: station.latitude,
    name: station.name,
    online: station.online,
    job: station.job,
  };
}

export function stationsToKm220MapPorts(stations) {
  return (stations || [])
    .filter(s => !s.isError && s.latitude != null && s.longitude != null)
    .map(stationToKm220MapPort)
    .filter(Boolean);
}
